import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { blueGreyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const MultiIconCellRidesStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "multi-icon-cell-ride",
})`
  color: ${blueGreyMui._500};
  display: flex;
  align-items: center;
  line-height: 1px;
  margin-inline-start: 3px;
  gap: 8px;
  /* @idui/tooltip injected wrapper */
  > span[style*="display: inline;"] {
    min-width: 15px;
  }

  .color-circle-single-select {
    margin-inline-start: 7px;
    margin-inline-end: 5px;
  }

  .info_icons_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 45px;
  }

  .course_icon_wrapper {
    width: 13px;
  }

  .hub_icon_wrapper {
    width: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    svg.nearby_funnel {
      margin-inline-start: 0;
    }
  }
`;

export const MultiIconCellRideMapStyled = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "multi-icon-cell-ride-map",
})`
  color: ${blueGreyMui._500};
  display: flex;
  align-items: center;
  line-height: 1px;
  margin-inline-start: 3px;
  gap: 4px;
  /* @idui/tooltip injected wrapper */
  > span[style*="display: inline;"] {
    min-width: 13px;
  }

  .color-circle-single-select {
    margin-inline-start: 7px;
    margin-inline-end: 5px;
  }

  .info_icons_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 45px;
  }

  .course_icon_wrapper {
    width: 13px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    svg.nearby_funnel {
      margin-inline-start: 0;
    }
  }
`;

/** Live map “Arrival time” column: delay icon + minutes only. */
export const CellLiveMapArrivalTimeStyled = styled.div.attrs<IStyledAttributes>(
  () => ({
    [DATA_E2E_KEY]: "live-map-arrival-time-cell",
  }),
)`
  color: ${blueGreyMui._500};
  display: grid;
  align-items: center;
  grid-template-columns: 20px 1fr;
  justify-content: start;
  margin-inline-start: 3px;
  gap: 3px;
  width: 100%;
`;

/** Live map last column: SMS + open ride (no arrival delay). */
export const CellLiveMapRowActionsStyled = styled.div.attrs<IStyledAttributes>(
  () => ({
    [DATA_E2E_KEY]: "live-map-row-actions-cell",
  }),
)`
  color: ${blueGreyMui._500};
  display: grid;
  align-items: center;
  grid-template-columns: 27px 27px;
  margin-inline-start: 3px;
  gap: 3px;
  width: 100%;

  svg.click_out {
    cursor: pointer;
    justify-self: center;
    line-height: 0;
    transform: translateY(-3px);
  }
`;
